import loadTraits from './traits';
import loadBlocks from './blocks';
import loadComponents from './components';

export default (editor, opts = {}) => {

  const lang = {
      cc: "forms",
      absolute: "absolutna",
      actions: "Akcje",
      activateCode: "Aktywuj kod rabat w tle",
      addImage: "Dodaj obrazek",
      alt: "Tekst zastepczy",
      background: "Tło",
      basic: "Podstawowe",
      block: "Blok",
      border: "Obramowanie",
      bottom: "Dół",
      boxShadow: "Cień",
      button: "Przycisk",
      cat1: "Szablony Pop-up",
      cat2: "Zapisane szablony",
      cat3: "Szablony Widget",
      cat4: "Szablony Email",
      cat5: "Szablony Web push",
      checkbox: "Checkbox",
      checkboxField: "Pole Checkbox",
      circle: "Okrąg",
      classes: "Klasy",
      click: "Kliknięcie",
      closeIcon: "Ikona zamknięcia",
      closePopup: "Zamknij pop-up",
      color: "Kolor",
      column: "kolumna",
      columns: "kolumny",
      componentSettings: "Ustawienia elementu",
      custom: "Własne",
      customCode: "Własny kod",
      customFont: "Własna czcionka",
      decorations: "Dekoracja",
      dimension: "Rozmiar",
      display: "Wyświelatnie",
      dropHere: "Upuści pliki tutaj lub kliknij",
      elements: "Elementy",
      extra: "Dodatkowe",
      fixed: "Pływanie",
      float: "Wyrównanie",
      fontFamily: "Czcionka",
      fontSize: "Rozmiar",
      fontWeight: "Grubość",
      form: "Formularz",
      forms: "Formularze",
      general: "Ogólne",
      groupOfProducts: "Grupa produktów",
      height: "Wysokość",
      hover: "Najechanie",
      image: "Obrazek",
      inline: "Linnia",
      inlineB: "Pełna Linnia",
      input: "Pole",
      label: "Tytuł",
      layers: "Warstwy",
      layout: "Układ",
      left: "Lewa",
      letterSpacing: "Odstęp",
      lineHeight: "Wysokość linni",
      link: "Link",
      location: "Lokacja",
      margin: "Margines",
      move: "Przenieś do koszyka i atywuj rabat",
      name: "Nazwa",
      none: "brak",
      padding: "Padding",
      parity: "Parzysty",
      perspective: "Perspektywa",
      popupSettings: "Ustawienia Pop-up",
      popupSettingsTitle: "Ustaw pozycję pop-up",
      position: "Pozycja",
      price: "Cena",
      quantity: "Ilość",
      radio: "Radio",
      radioField: "Pole Radio",
      radius: "zaokrąglenie",
      rectangle: "Prostokąt",
      relative: "relatywnie",
      required: "Wymagane",
      right: "Prawo",
      rotate: "obrót",
      select: "Wybierz",
      selected: "Wybrane",
      selectElement: "Wybierz element przed edycją",
      selectImage: "Wybierz obrazek",
      settings: "Ustawienia",
      shapes: "Figury",
      showCode: "Pokaż kod rabatowy",
      square: "Kwadrat",
      state: "- Stan -",
      static: "statyczne",
      style: "styl",
      templates: "Szablony",
      text: "Tekst",
      textAlign: "Pozycja tekstu",
      textArea: "Obszar tekstowy",
      textShadow: "Cień tekstu",
      top: "Góra",
      transform: "Przesunięcie",
      transition: "Przejście",
      typography: "Typografia",
      width: "Szerokość",
      prop: {
          none: "brak",
          left: "lewa",
          right: "prawa",
          block: "blok",
          inline: "w linni",
          static: "statyczna",
          relative: "relatywna",
          absolute: "absolutna",
          fixed: "pływająca",
          "inline-block": "w bloku",
      },
      enterHere: "Wpisz tekst tutaj",
      method: "Metoda",
      action: "Akcja",
      stateEl: "Stan",
      for: "Dla",
      field: "Pole",
      placeholder: 'Tekst zastępczy',
      value: 'Wartość',
      type: 'Typ',
      options: 'Opcje',
      checked: 'Zaznaczone',
      email: 'Email',
      password: 'Hasło',
      number: 'Numer',
      submit: 'Wyślij',
      reset: 'Reset',
      selectOption: '- Wybierz opcję -',
      option: 'Opcja',
      normal: 'Normal',
      success: 'Sukces',
      error: 'Błąd',
  };

  if(!window.lang) {
    window.lang = lang;
  }

  const config = {
    blocks: ['form', 'input', 'textarea', 'select',
      'button', 'label', 'checkbox', 'radio'],
    labelTraitMethod: window.lang['method'],
    labelTraitAction: window.lang['action'],
    labelTraitState: window.lang['stateEl'],
    labelTraitId: 'ID',
    labelTraitFor: window.lang['for'],
    labelInputName: window.lang['field'],
    labelTextareaName: window.lang['textArea'],
    labelSelectName: window.lang['select'],
    labelCheckboxName: window.lang['checkboxField'],
    labelRadioName: window.lang['checkboxRadio'],
    labelButtonName: window.lang['button'],
    labelTraitName: window.lang['name'],
    labelTraitPlaceholder: window.lang['placeholder'],
    labelTraitValue: window.lang['value'],
    labelTraitRequired: window.lang['required'],
    labelTraitType: window.lang['type'],
    labelTraitOptions: window.lang['options'],
    labelTraitChecked: window.lang['checked'],
    labelTypeText: window.lang['text'],
    labelTypeEmail: window.lang['email'],
    labelTypePassword: window.lang['password'],
    labelTypeNumber: window.lang['number'],
    labelTypeSubmit: window.lang['submit'],
    labelTypeReset: window.lang['reset'],
    labelTypeButton: window.lang['button'],
    labelNameLabel: window.lang['label'],
    labelForm: window.lang['form'],
    labelSelectOption: window.lang['selectOption'],
    labelOption: window.lang['option'],
    labelStateNormal: window.lang['normal'],
    labelStateSuccess: window.lang['success'],
    labelStateError: window.lang['error'],
    category: window.lang['forms'],
    ...opts
  };

  loadComponents(editor, config);
  loadTraits(editor, config);
  loadBlocks(editor, config);
};
